import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, HttpBackend, HttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { httpInterceptorProviders } from './http-interceptors';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './components/app.component';
import { HttpClientService } from './http-client.service';
import { environment } from '../environments/environment';
import { SwitchGroupsComponent } from './components/switch-groups/switch-groups.component';
import { SharedModule } from './shared/shared.module';
import { ScheduledMaintainanceComponent } from './components/scheduled-maintainance/scheduled-maintainance.component';
import { StoreModule } from '@ngrx/store';
import { AuthService } from './core/auth.service';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalCustomNavigationClient, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { EventType, InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { provideHttpClient } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MsalService } from '@azure/msal-angular';
import { AuthorizationInterceptor } from './http-interceptors/authorization-interceptor';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { orderBy } from 'lodash';
import { NonTerritoryDashboardComponent } from './NewUI-modules/components/non-territory-dashboard/non-territory-dashboard.component';
import { MatChipsModule} from '@angular/material/chips';
import { OrdersService } from './feature-modules/orders/shared/orders.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChatbotComponent } from './NewUI-modules/components/chat-bot/chat-bot.component';
import { FeatureFlagService } from 'src/betauser-flag.service';
import { FilterSideNavComponent } from './NewUI-modules/components/filter-side-nav/filter-side-nav.component';
import {OrderDateRangeComponent} from   './NewUI-modules/components/order-date-range/order-date-range.component';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // or MatMomentDateModule
import {TerritoryViewComponent} from './NewUI-modules/components/territory-view/territory-view.component';
import { AppLayoutComponent } from './NewUI-modules/components/app-layout/app-layout.component';
import { TerritoryDashboardComponent } from './NewUI-modules/components/territory-dashboard/territory-dashboard.component';








export function getAdalConfig() {
  return {
    tenant: environment.adalConfig.tenant,
    clientId: environment.adalConfig.clientId,
    endpoints: environment.adalConfig.endpoints,
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
    cacheLocation: 'sessionStorage'
  };
}


export function loadConfig(featureFlagService: FeatureFlagService) {
  return () => featureFlagService.getConfig();
}




@NgModule({ declarations: [
        AppComponent,
        SwitchGroupsComponent,
        ScheduledMaintainanceComponent,
        NonTerritoryDashboardComponent,
        ChatbotComponent,
        FilterSideNavComponent,
        OrderDateRangeComponent,
        TerritoryViewComponent,
        AppLayoutComponent,
        TerritoryDashboardComponent
    ],
    bootstrap: [AppComponent],
    exports: [CommonModule,
        FormsModule], imports: [SharedModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        NgbModule,
        AppRoutingModule,
        CoreModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatListModule,
        MatChipsModule,
        MatTooltipModule,  
       MatDatepickerModule,
       MatNativeDateModule, // or MatMomentDateModule       TerritoryViewComponent,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (handler: HttpBackend) => new TranslateHttpLoader(new HttpClient(handler), './assets/i18n/', '.json'),
                deps: [HttpBackend]
            }
        }),
        MsalModule.forRoot(new PublicClientApplication({
            auth: {
                clientId: environment.adalConfig.clientId,
                authority: 'https://login.microsoftonline.com/' + environment.adalConfig.tenant,
                redirectUri: window.location.origin
            },
            cache: {
                cacheLocation: "sessionStorage"
            },
        }), {
            interactionType: InteractionType.Redirect, // Msal Guard Configuration
            authRequest: {
                scopes: ["user.read"]
            },
        }, {
            interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
            protectedResourceMap: new Map([
                ["https://graph.microsoft.com/v1.0/me", ["offline_access", "openid", "profile"]]
            ]),
        })], providers: [
            
        httpInterceptorProviders,
        FeatureFlagService,
    
        OrdersService,
        { provide: HttpClientService, useFactory: (http: HttpClient, router: Router) => new HttpClientService(http, router), deps: [HttpClient, Router] },
        MsalGuard,
        provideHttpClient(withInterceptorsFromDi())
    ] })

 export class AppModule { }
 


